module.exports = __webpack_public_path__ + "static/media/Sama_logo1.2861e7ad.png";